import { messages } from "../i18n/index.ts";

interface BackButtonProps {
  onClick: () => void;
  label?: string;
}

/** Tüm üst başlıklarda aynı, belirgin ve erişilebilir geri kontrolü. */
export function BackButton({ onClick, label = messages.common.back }: BackButtonProps) {
  return (
    <button
      type="button"
      className="btn-ghost back-button"
      onClick={onClick}
      aria-label={label}
    >
      <svg viewBox="0 0 24 24" width="22" height="22" aria-hidden="true">
        <path d="M15 18 9 12l6-6" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    </button>
  );
}
